import { disputesActionTypes } from '../disputes-action-types';
import { IAction, IState } from '../disputes-interfaces';
import axios from 'axios';
import { BASE_URL } from '../../../../config/environmentConfig';
import { sendSentryMessage } from '../../../utils/sentry-helper';
import { getDisputesQueryParams } from './disputes';
import * as React from 'react';
import { requestErrorHandler } from '../../../utils/newApplicationUtils';
import { LOADING_FIELDS } from '../../../constants/loading-modal/loading-form';
import download from 'downloadjs';
import { GET, PUT } from '../../store-helper';
import { IDisputeQueuesFilters } from '../../../components/disputes/DisputeQueuesFilterSection';
import { removeNullValues } from '../../../utils/utilities';

interface IFetchDisputeQueueItem {
    dispatch: React.Dispatch<IAction>;
    searchParams: IDisputeQueuesFilters;
}

export const fetchDisputeQueues = async ({ dispatch, searchParams }: IFetchDisputeQueueItem): Promise<void> => {
    try {
        dispatch({ type: disputesActionTypes.SET_DISPUTE_QUEUE_LOADING, payload: true });

        const formattedSearchParams = removeNullValues({ ...searchParams });


        const res = await GET({
            pathname: `${BASE_URL.PAYMENTS}/Disputes/queue`,
            params: formattedSearchParams
        });

        dispatch({ type: disputesActionTypes.FETCH_DISPUTE_QUEUES, payload: res ?? null });
    } catch (e) {
        console.log('get disputes queues error', e.response);
        dispatch({ type: disputesActionTypes.SET_DISPUTE_QUEUE_LOADING, payload: false });
    }
};

interface IBodyProps {
    name?: string,
    isPined?: boolean,
    emailRecipient?: string,
    openItemsAlert?: boolean,
    newItemsAlert?: boolean,
}

export const changeDisputeQueueParams = async (id: string, body: IBodyProps ): Promise<void> => {
    await PUT({
        pathname: `${BASE_URL.PAYMENTS}/Disputes/${id}/queue`,
        body
    });
};

export const createDisputeQueue = async (formik: any, file: any): Promise<void> => {
    const provider = formik.values[LOADING_FIELDS.PROVIDERS];
    const type = formik.values[LOADING_FIELDS.TYPE];
    const name = formik.values[LOADING_FIELDS.NAME];
    const autoMatch = formik.values[LOADING_FIELDS.AUTO_MATCH];
    const openItemsAlert = formik.values[LOADING_FIELDS.OPEN_ITEMS_ALERT];
    const newItemsAlert = formik.values[LOADING_FIELDS.NEW_ITEMS_ALERT];
    const emailRecipient = formik.values[LOADING_FIELDS.EMAIL];
    const partnerId = formik.values[LOADING_FIELDS.PARTNER_ID];

    const URL = `${BASE_URL.PAYMENTS}/Disputes/queue?name=${name}&partnerId=${partnerId}&source=${provider}&type=${type}&autoMatch=${autoMatch}&emailRecipient=${emailRecipient}&openItemsAlert=${openItemsAlert}&newItemsAlert=${newItemsAlert}`;

    const formData = new FormData();
    formData.append('file', file);
    return await axios.post(URL, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

export const fetchDisputeQueueData = async (dispatch: React.Dispatch<IAction>, state: IState, id: string): Promise<void> => {
    dispatch({ type: disputesActionTypes.SET_DISPUTES_LOADING, payload: true });
    try {
        const params = getDisputesQueryParams(state, false, null, null);

        const data = await GET({
            pathname: `${BASE_URL.PAYMENTS}/Disputes/${id}/queue-items`,
            params
        });

        dispatch({ type: disputesActionTypes.FETCH_DISPUTES_SUCCESS, payload: data?.items?.rows ?? [], totalItemCount: data?.items?.totalItemCount || 0 });

    } catch (error) {
        sendSentryMessage({ name: `GET Fetch search filter list error`, context: error });
        dispatch({ type: disputesActionTypes.FETCH_DISPUTES_FAIL });
    }
};

export const fetchDisputeQueueArchivedData = async (dispatch: React.Dispatch<IAction>, state: IState): Promise<void> => {
    dispatch({ type: disputesActionTypes.SET_DISPUTES_LOADING, payload: true });
    try {
        const params = {
            pageSize: state.pageSize,
            pageNumber: state.pageNumber + 1
        };

        const data = await GET({
            pathname: `${BASE_URL.PAYMENTS}/Disputes/archived-queue-items`,
            params
        });

        dispatch({ type: disputesActionTypes.FETCH_DISPUTES_SUCCESS, payload: data?.items?.rows ?? [], totalItemCount: data?.items?.totalItemCount || 0 });

    } catch (error) {
        sendSentryMessage({ name: `GET Fetch search filter list error`, context: error });
        dispatch({ type: disputesActionTypes.FETCH_DISPUTES_FAIL });
    }
};

export const setDisputeQueueRetry = async (queueId: string): Promise<void> => {
    await PUT({
        pathname: `${BASE_URL.PAYMENTS}/Disputes/${queueId}/retry`
    });
};

export const setDisputesQueueDataToDefault = (dispatch: React.Dispatch<IAction>): void => {
    dispatch({ type: disputesActionTypes.SET_DISPUTES_QUEUE_DATA_TO_DEFAULT });
};

export const setDisputesQueueItemsListDataToDefault = (dispatch: React.Dispatch<IAction>): void => {
    dispatch({ type: disputesActionTypes.SET_DISPUTES_QUEUE_ITEMS_LIST_DATA_TO_DEFAULT });
};

export const fetchReportProvidersList = async ({ dispatch }): Promise<void> => {
    try {
        dispatch({ type: disputesActionTypes.SET_REPORT_PROVIDERS_LIST_LOADING, payload: true });
        const { data } = await axios.get(`${BASE_URL.PAYMENTS}/Disputes/report-providers-list`);
        dispatch({ type: disputesActionTypes.FETCH_REPORT_PROVIDERS_LIST, payload: data ?? [] });
    } catch (error) {
        dispatch({ type: disputesActionTypes.FETCH_REPORT_PROVIDERS_LIST, payload: [] });
        console.log('get disputes queues error', error.response);
        requestErrorHandler(error);
    }

};

interface IReportTemplate {
    type: string;
    provider: string;
    label: string;
}

export const getReportTemplate = async ({ provider, type, label }: IReportTemplate): Promise<void> => {
    try {
        const { data } = await axios.get(`${BASE_URL.PAYMENTS}/Disputes/report-template`, {
            params: {
                provider,
                type
            }
        });
        const blob = new Blob([data], { type: 'text/csv' });
        download(blob, `${label}.csv`);
    } catch (error) {
        console.log('get Report Template error', error.response);
        requestErrorHandler(error);
    }
};
